module.exports = __webpack_public_path__ + "img/hoag1.d9c1b15f.png";